import React from 'react';
import PropTypes from 'prop-types';
import track from 'react-tracking';
import { ModalDialog, ActionRow, Button } from '@edx/paragon';
import { defineMessages, FormattedMessage, injectIntl } from 'gatsby-plugin-react-intl';
import { submitEvent } from '@utils/analytics';
import { intlShape } from '@prospectus/common/types/intlShape';

function EnterpriseEnrollmentInformModal({
  intl, tracking, isOpen, close, enrollFlow,
}) {
  const messages = defineMessages({
    'prospectus.enterprise.enrollment.inform.modal.title': {
      id: 'prospectus.enterprise.enrollment.inform.modal.title',
      description: 'Title for Enterprise Enrollment Inform modal.',
      defaultMessage: 'Enterprise enrolment inform modal',
    },
  });

  const submitAnalytics = () => {
    const componentProps = {};
    submitEvent(tracking, componentProps, 'edx.bi.link.enterprise.enrollment.inform.continue.clicked');
  };

  const handleContinueSubmit = (event) => {
    submitAnalytics();
    enrollFlow(event);
    close();
  };

  return (
    <ModalDialog
      title={intl.formatMessage(messages['prospectus.enterprise.enrollment.inform.modal.title'])}
      isOpen={isOpen}
      onClose={close}
      size="lg"
      hasCloseButton={false}
    >
      <ModalDialog.Header>
        <ModalDialog.Title>
          <FormattedMessage
            id="prospectus.enterprise.enrollment.inform.modal.header"
            description="Header message for Enterprise Enrollment Inform modal."
            defaultMessage="Before you can enroll"
          />
        </ModalDialog.Title>
      </ModalDialog.Header>

      <ModalDialog.Body>
        <p>
          <FormattedMessage
            id="prospectus.enterprise.enrollment.inform.modal.body"
            description="Body content for Enterprise Enrollment Inform modal."
            defaultMessage="It looks like you are currently logged in to an account with access to an Enterprise profile. In order to use your organization's learning program, you will need to enroll in this course using your Enterprise profile."
          />
        </p>
      </ModalDialog.Body>

      <ModalDialog.Footer>
        <ActionRow>
          <ModalDialog.CloseButton variant="tertiary">
            Cancel
          </ModalDialog.CloseButton>
          <Button onClick={handleContinueSubmit}>
            <FormattedMessage
              id="prospectus.enterprise.enrollment.inform.modal.button"
              description="Continue button which executes enrollment flow."
              defaultMessage="Continue"
            />
          </Button>
        </ActionRow>
      </ModalDialog.Footer>
    </ModalDialog>
  );
}

EnterpriseEnrollmentInformModal.propTypes = {
  intl: intlShape.isRequired,
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  enrollFlow: PropTypes.func,
  tracking: PropTypes.shape(),
};
EnterpriseEnrollmentInformModal.defaultProps = {
  isOpen: false,
  close: () => {},
  enrollFlow: () => {},
  tracking: {},
};

export default track(
  { component: 'enterprise-enroll-inform-continue-button' },
)(injectIntl(EnterpriseEnrollmentInformModal));
